import { SelectOption } from '@core/ui';

export const DEFAULT_SALUTATION_OPTIONS: SelectOption<string | null>[] = [
  { label: 'Keine Angabe', value: null, isResetOption: true },
  { label: 'Herr', value: 'Herr' },
  { label: 'Frau', value: 'Frau' },
  { label: 'Divers', value: 'Divers' },
];
